export default __webpack_public_path__ + "static/media/quantsapp-partner.052eac95.svg";